import { FC, ReactNode } from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { useViewportScale } from '~/utils/hooks/useViewportScale';
import { useEffectiveFitMode } from '~/utils/hooks/useEffectiveFitMode';
import { SCALED_VIEWPORT_CONTENT_ATTR } from '~/utils/scaledViewport';

interface ScaledViewportProps {
  children: ReactNode;
}

const ViewportWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: #121212;
`;

const ScaledContent = styled.div<{
  $scaleX: number;
  $scaleY: number;
  $width: number;
  $height: number;
}>`
  width: ${({ $width }) => $width}px;
  height: ${({ $height }) => $height}px;
  transform: scale(${({ $scaleX, $scaleY }) => `${$scaleX}, ${$scaleY}`});
  transform-origin: center center;
  flex-shrink: 0;
`;

export const ScaledViewport: FC<ScaledViewportProps> = observer(
  ({ children }) => {
    const effectiveMode = useEffectiveFitMode();
    const { scaleX, scaleY, width, height } = useViewportScale(effectiveMode);

    return (
      <ViewportWrapper>
        <ScaledContent
          {...{ [SCALED_VIEWPORT_CONTENT_ATTR]: '' }}
          $scaleX={scaleX}
          $scaleY={scaleY}
          $width={width}
          $height={height}
        >
          {children}
        </ScaledContent>
      </ViewportWrapper>
    );
  },
);
